import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import type { Reporter } from './types';

export const reporter: Reporter = {
  error(message, messageContext, originalError) {
    const errorToReport = originalError instanceof Error ? originalError : new Error(message);
    const context =
      originalError instanceof Error ? messageContext : { ...messageContext, originalError };
    try {
      datadogLogs.logger.error(message, { ...context, error: errorToReport });
      if (datadogRum.getInitConfiguration()) {
        datadogRum.addError(errorToReport, context);
      }
    } catch (e) {
      // Swallow reporter failures so a Datadog outage never breaks the calling UI.
      console.error('[observability] reporter.error failed', e);
    }
  },
  info(message, messageContext) {
    try {
      // No datadogRum.addError: it mints a synthetic Error and files it in the
      // RUM Error Explorer, which an info event must not do (EE-706).
      datadogLogs.logger.info(message, messageContext);
    } catch (e) {
      // Swallow reporter failures so a Datadog outage never breaks the calling UI.
      console.error('[observability] reporter.info failed', e);
    }
  },
  action(name, context) {
    try {
      if (datadogRum.getInitConfiguration()) {
        datadogRum.addAction(name, context);
      }
    } catch (e) {
      // Swallow reporter failures so a Datadog outage never breaks the calling UI.
      console.error('[observability] reporter.action failed', e);
    }
  },
};
